<div id="load-claro-page" class="container-fluid my-auto">
    <div id="div-loader-1">
        <div 
            id="div-loader-2"
            class="w-28 h-28 spinner border-l-teal-blue animate-spin"
        >
        </div>
    </div>
</div>